<template>
  <v-form v-model="valid">
    <div  class="text-left d-flex flex-column max-width ">
      <v-container 
        fluid :class="containerClasses" 
        class="bg-blue-lighten-5 ">

      <div class="text-center mb-10">
        <!-- Responsive Textgrößen -->
        <h1 :class="titleClasses" class="font-weight-bold mb-4">Noch Fragen offen?</h1>
        <p :class="subtitleClasses" class="font-weight-regular">
          Melde dich gerne bei uns – wir helfen weiter!
        </p>
      </div>



        <v-row no-gutters>
          <!-- Erste Zeile: Name und Email -->
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="firstname"
              :counter="16"
              :rules="nameRules"
              label="Vorname"
              clearable
              required
              variant="outlined"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="lastname"
              :counter="16"
              :rules="nameRules"
              label="Nachname"
              clearable
              variant="outlined"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field
              v-model="email"
              :rules="emailRules"
              label="E-mail"
              variant="outlined"
              clearable
              required
            ></v-text-field>
          </v-col>

          <!-- Zweite Zeile: Select und Budget -->
          <v-col cols="12" md="6" class="bg-blue-lighten-5">
            <v-select
              clearable
              chips
              label="Welche Art von Fotografie interessiert Dich?"
              :items="['Fotografie', 'Hochzeit', 'Social Media', 'Influencer', 'Sonstiges']"
              variant="outlined"
            ></v-select>
          </v-col>

          <v-col cols="12" md="6">
            <v-number-input
              label="Geschätztes Budget in €"
              control-variant="split"
              variant="outlined"
              :min="100"
              :max="100000"
            ></v-number-input>
          </v-col>

          <!-- Dritte Zeile: Textarea (volle Breite) -->
          <v-col cols="12">
            <v-textarea
              :model-value="value"
              :rules="rules"
              label="Weitere Details"
              counter
              clearable
              variant="outlined"
              rows="3"
            ></v-textarea>
          </v-col>

          <!-- Vierte Zeile: Button (zentriert) -->
          <v-col cols="12" class="text-center">
            <v-btn
              :class="buttonSize"
              type="submit"
              :disabled="!valid"
              color="primary"
              large
              size="x-large"
            >
              Anfrage senden
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-form>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ref } from 'vue';
import { useResponsive } from '@/composables/useResponsive';

export default defineComponent({
  name: 'ContactComponent',

  setup() {
    const valid = ref(false);
    const firstname = ref('');
    const lastname = ref('');
    const email = ref('');
    const nameRules = [(v: string) => !!v || 'Name is required'];
    const emailRules = [
      (v: string) => !!v || 'Email is required',
      (v: string) => /.+@.+\..+/.test(v) || 'Email must be valid'
    ];

    const rules = [(v: string) => v.length <= 2000 || 'Max 2000 characters'];
    const value = ref('');
    const responsive = useResponsive();

    return {
      valid,
      firstname,
      lastname,
      email,
      nameRules,
      emailRules,
      rules,
      value,
      ...responsive
    };
  }
});
</script>

<style scoped>

</style>